import type { FC } from 'react';
import type React from 'react';
import { Box, Typography } from '@mui/material';

import { internationalDateFormat } from 'src/helper/helper';

import { styles } from './styles';

export interface ChangelogRowIcon {
  src: string;
  alt: string;
}

interface ChangelogRowProps {
  authorName: string;
  actionDescription: React.ReactNode;
  date: Date;
  icon: ChangelogRowIcon;
  children?: React.ReactNode;
}

const ChangelogRow: FC<ChangelogRowProps> = ({
  authorName,
  actionDescription,
  date,
  icon,
  children,
}) => (
  <Box sx={styles.changelogRow}>
    <Box sx={styles.changelogRowIconBox}>
      <img src={icon.src} alt={icon.alt} />
    </Box>

    <Box sx={styles.changelogRowContents}>
      <Box>
        <Typography component="span" sx={{ fontWeight: 'bold' }}>
          {authorName}
        </Typography>{' '}
        <Typography sx={styles.changelogRowDescriptionText} component="span">
          {actionDescription}
        </Typography>{' '}
        <Typography sx={styles.changelogRowDateText} component="span">
          · {internationalDateFormat(date)}
        </Typography>
      </Box>

      {children && <Box>{children}</Box>}
    </Box>
  </Box>
);

export default ChangelogRow;
